var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApachCamel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130.21 130.01",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 333.48,
    x2: 477,
    y1: 702.6,
    y2: 563.73,
    gradientTransform: "matrix(.99206 0 0 .99206 94.038 276.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69923",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79A23",
    offset: 0.10996
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97826",
    offset: 0.94502
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 333.48,
    x2: 477,
    y1: 702.6,
    y2: 563.73,
    gradientTransform: "matrix(.99206 0 0 .99206 94.038 276.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69923",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79A23",
    offset: 0.080478
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97826",
    offset: 0.41874
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 633.55,
    x2: 566.47,
    y1: 814.6,
    y2: 909.12,
    gradientTransform: "translate(-85.421 56.236)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6e423",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79A23",
    offset: 0.41191
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97826",
    offset: 0.73271
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-437.89 -835.29)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 503.1,
    cy: 900.29,
    r: 62.52,
    fill: "url(#a)",
    stroke: "url(#b)",
    strokeLinejoin: "round",
    strokeWidth: 4.9603
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487.89 873.64c-0.88906-1e-3 -1.7897 5e-3 -2.6875 0.0312-1.0437 0.0308-2.4459 0.36218-4.0625 0.90625 27.309 20.737 37.127 58.146 20.25 90.656 0.57317 0.0149 1.142 0.0625 1.7188 0.0625 30.844 0 56.62-21.493 63.281-50.312-19.573-22.943-46.118-41.294-78.5-41.344z",
    fill: "url(#c)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481.14 874.58c-9.0682 3.0518-26.368 13.802-43 28.156 1.2631 34.195 28.961 61.607 63.25 62.5 16.877-32.51 7.0594-69.919-20.25-90.656z",
    fill: "#28170b",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-85.421 56.236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m590.31 806.31c-0.47239-0.0321-0.93151 0.0284-1.375 0.25-5.5992 2.8011 0 14 0 14-16.807 14.009-13.236 37.938-32.844 37.938-10.689 0-21.322-12.293-32.531-19.812-0.1443 1.7733-0.25 3.5645-0.25 5.375 0 24.515 13.51 45.863 33.469 57.063 5.5828-0.70321 11.158-2.1139 15.344-4.9062 21.992-14.662 27.452-42.557 36.438-56.031 5.5962-8.4063 31.824-7.6769 33.594-11.219 2.8041-5.6022-5.6021-14-8.4062-14h-22.406c-1.5655 0-4.0253-2.7812-5.5938-2.7812h-8.4062s-3.7245-5.6503-7.0312-5.875z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApachCamel);
export default __webpack_public_path__ + "static/media/apach-camel.b3d1f2261dc86c4792a0d8bf4221263e.svg";
export { ForwardRef as ReactComponent };